// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/public/how-bg.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* WhySection styles */

/* How MAIA Delivers Better Care Section */
.how-maia-section {
  position: relative;
  padding: 4rem 0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}

.how-maia-section::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 30%;
  right: 0;
  height: 200px;
  background: radial-gradient(circle, rgba(0, 123, 255, 0.1) 2px, transparent 2px);
  background-size: 20px 20px;
  transform: translateY(-50%);
  z-index: -1;
}

.how-maia-title {
  font-size: 32px;
  font-weight: 700;
  color: #333;
  margin-bottom: 3rem;
}

.step-card {
  padding: 3rem;
  margin-left: 2rem;
  margin-right: 2rem;
  border-radius: 10px;
  height: 100%;
  position: relative;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.step-card-blue {
  background: rgba(15, 74, 190, 1);
  color: white;
}

.step-card-white {
  background: rgba(253, 253, 253, 1);
  color: #333;
  border: 1px solid #e9ecef;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  transition: background 0.5s ease;
}

.step-card-white:hover {
  background: rgba(15, 74, 190, 1);
  color: white;
}

.step-card-white:hover .step-number{
  color: white;
}

.step-card-white:hover .step-title {
  color: white;
}

.step-card-white:hover .step-description {
  color: rgba(255, 255, 255, 1);
}

.step-number {
  font-size: 64px;
  font-weight: 300;
  line-height: 1;
  margin-top: 2rem;
  margin-bottom: 5rem;
}

.step-card-blue .step-number {
  color: rgba(255, 255, 255, 1);
}

.step-card-white .step-number {
  color: rgba(1, 6, 15, 1);
}

.step-card-white .step-title {
  color: rgba(1, 6, 15, 1);
}

.step-card-white .step-description {
  color: rgba(116, 116, 116, 1);
}

.step-title {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 2rem;
  line-height: 1.2;
}

.step-description {
  font-size: 16px;
  line-height: 1.6;
  margin-bottom: 2rem;
  opacity: 0.9;
}

.step-card-white .step-description {
  color: #666;
}

/* Responsive adjustments */
@media (max-width: 1200px) {
  .step-card {
    padding: 2.5rem;
    margin-left: 1.5rem;
    margin-right: 1.5rem;
  }
  
  .step-number {
    font-size: 56px;
    margin-bottom: 4rem;
  }
  
  .step-title {
    font-size: 22px;
  }
}

@media (max-width: 992px) {
  .step-card {
    padding: 2rem;
    margin-left: 1rem;
    margin-right: 1rem;
  }
  
  .step-number {
    font-size: 48px;
    margin-bottom: 3rem;
  }
  
  .step-title {
    font-size: 20px;
  }
  
  .step-description {
    font-size: 15px;
  }
}

@media (max-width: 768px) {
  .how-maia-section {
    padding: 3rem 0;
  }
  
  .how-maia-title {
    font-size: 28px;
    margin-bottom: 2.5rem;
  }
  
  .step-card {
    padding: 1.75rem;
    margin-left: 0.5rem;
    margin-right: 0.5rem;
    margin-bottom: 1rem;
  }
  
  .step-number {
    font-size: 42px;
    margin-top: 1rem;
    margin-bottom: 2.5rem;
  }
  
  .step-title {
    font-size: 18px;
    margin-bottom: 1.5rem;
  }
  
  .step-description {
    font-size: 14px;
    margin-bottom: 1.5rem;
  }
  
  .how-maia-section::before {
    display: none;
  }
}

@media (max-width: 576px) {
  .how-maia-section {
    padding: 2rem 0;
  }
  
  .how-maia-title {
    font-size: 24px;
    margin-bottom: 2rem;
  }
  
  .step-card {
    padding: 1.5rem;
    margin-left: 0.25rem;
    margin-right: 0.25rem;
    margin-bottom: 1rem;
  }
  
  .step-number {
    font-size: 36px;
    margin-top: 0.5rem;
    margin-bottom: 2rem;
  }
  
  .step-title {
    font-size: 16px;
    margin-bottom: 1rem;
  }
  
  .step-description {
    font-size: 13px;
    margin-bottom: 1rem;
    line-height: 1.5;
  }
}

@media (max-width: 480px) {
  .how-maia-section {
    padding: 1.5rem 0;
  }
  
  .how-maia-title {
    font-size: 20px;
    margin-bottom: 1.5rem;
  }
  
  .step-card {
    padding: 1.25rem;
    margin-left: 0;
    margin-right: 0;
    margin-bottom: 0.75rem;
  }
  
  .step-number {
    font-size: 32px;
    margin-top: 0;
    margin-bottom: 1.5rem;
  }
  
  .step-title {
    font-size: 15px;
    margin-bottom: 0.75rem;
  }
  
  .step-description {
    font-size: 12px;
    margin-bottom: 0.75rem;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/LandingPage/WhySection.css"],"names":[],"mappings":"AAAA,sBAAsB;;AAEtB,0CAA0C;AAC1C;EACE,kBAAkB;EAClB,eAAe;EACf,yDAA2C;EAC3C,wBAAwB;EACxB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,QAAQ;EACR,aAAa;EACb,gFAAgF;EAChF,0BAA0B;EAC1B,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,WAAW;EACX,yBAAyB;EACzB,0CAA0C;EAC1C,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA,2BAA2B;AAC3B;EACE;IACE,eAAe;IACf,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;IACb,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,oBAAoB;IACpB,qBAAqB;IACrB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;IACnB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,aAAa;IACb,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,sBAAsB;EACxB;AACF","sourcesContent":["/* WhySection styles */\n\n/* How MAIA Delivers Better Care Section */\n.how-maia-section {\n  position: relative;\n  padding: 4rem 0;\n  background-image: url('/public/how-bg.png');\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n}\n\n.how-maia-section::before {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 30%;\n  right: 0;\n  height: 200px;\n  background: radial-gradient(circle, rgba(0, 123, 255, 0.1) 2px, transparent 2px);\n  background-size: 20px 20px;\n  transform: translateY(-50%);\n  z-index: -1;\n}\n\n.how-maia-title {\n  font-size: 32px;\n  font-weight: 700;\n  color: #333;\n  margin-bottom: 3rem;\n}\n\n.step-card {\n  padding: 3rem;\n  margin-left: 2rem;\n  margin-right: 2rem;\n  border-radius: 10px;\n  height: 100%;\n  position: relative;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\n.step-card-blue {\n  background: rgba(15, 74, 190, 1);\n  color: white;\n}\n\n.step-card-white {\n  background: rgba(253, 253, 253, 1);\n  color: #333;\n  border: 1px solid #e9ecef;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);\n  transition: background 0.5s ease;\n}\n\n.step-card-white:hover {\n  background: rgba(15, 74, 190, 1);\n  color: white;\n}\n\n.step-card-white:hover .step-number{\n  color: white;\n}\n\n.step-card-white:hover .step-title {\n  color: white;\n}\n\n.step-card-white:hover .step-description {\n  color: rgba(255, 255, 255, 1);\n}\n\n.step-number {\n  font-size: 64px;\n  font-weight: 300;\n  line-height: 1;\n  margin-top: 2rem;\n  margin-bottom: 5rem;\n}\n\n.step-card-blue .step-number {\n  color: rgba(255, 255, 255, 1);\n}\n\n.step-card-white .step-number {\n  color: rgba(1, 6, 15, 1);\n}\n\n.step-card-white .step-title {\n  color: rgba(1, 6, 15, 1);\n}\n\n.step-card-white .step-description {\n  color: rgba(116, 116, 116, 1);\n}\n\n.step-title {\n  font-size: 24px;\n  font-weight: 700;\n  margin-bottom: 2rem;\n  line-height: 1.2;\n}\n\n.step-description {\n  font-size: 16px;\n  line-height: 1.6;\n  margin-bottom: 2rem;\n  opacity: 0.9;\n}\n\n.step-card-white .step-description {\n  color: #666;\n}\n\n/* Responsive adjustments */\n@media (max-width: 1200px) {\n  .step-card {\n    padding: 2.5rem;\n    margin-left: 1.5rem;\n    margin-right: 1.5rem;\n  }\n  \n  .step-number {\n    font-size: 56px;\n    margin-bottom: 4rem;\n  }\n  \n  .step-title {\n    font-size: 22px;\n  }\n}\n\n@media (max-width: 992px) {\n  .step-card {\n    padding: 2rem;\n    margin-left: 1rem;\n    margin-right: 1rem;\n  }\n  \n  .step-number {\n    font-size: 48px;\n    margin-bottom: 3rem;\n  }\n  \n  .step-title {\n    font-size: 20px;\n  }\n  \n  .step-description {\n    font-size: 15px;\n  }\n}\n\n@media (max-width: 768px) {\n  .how-maia-section {\n    padding: 3rem 0;\n  }\n  \n  .how-maia-title {\n    font-size: 28px;\n    margin-bottom: 2.5rem;\n  }\n  \n  .step-card {\n    padding: 1.75rem;\n    margin-left: 0.5rem;\n    margin-right: 0.5rem;\n    margin-bottom: 1rem;\n  }\n  \n  .step-number {\n    font-size: 42px;\n    margin-top: 1rem;\n    margin-bottom: 2.5rem;\n  }\n  \n  .step-title {\n    font-size: 18px;\n    margin-bottom: 1.5rem;\n  }\n  \n  .step-description {\n    font-size: 14px;\n    margin-bottom: 1.5rem;\n  }\n  \n  .how-maia-section::before {\n    display: none;\n  }\n}\n\n@media (max-width: 576px) {\n  .how-maia-section {\n    padding: 2rem 0;\n  }\n  \n  .how-maia-title {\n    font-size: 24px;\n    margin-bottom: 2rem;\n  }\n  \n  .step-card {\n    padding: 1.5rem;\n    margin-left: 0.25rem;\n    margin-right: 0.25rem;\n    margin-bottom: 1rem;\n  }\n  \n  .step-number {\n    font-size: 36px;\n    margin-top: 0.5rem;\n    margin-bottom: 2rem;\n  }\n  \n  .step-title {\n    font-size: 16px;\n    margin-bottom: 1rem;\n  }\n  \n  .step-description {\n    font-size: 13px;\n    margin-bottom: 1rem;\n    line-height: 1.5;\n  }\n}\n\n@media (max-width: 480px) {\n  .how-maia-section {\n    padding: 1.5rem 0;\n  }\n  \n  .how-maia-title {\n    font-size: 20px;\n    margin-bottom: 1.5rem;\n  }\n  \n  .step-card {\n    padding: 1.25rem;\n    margin-left: 0;\n    margin-right: 0;\n    margin-bottom: 0.75rem;\n  }\n  \n  .step-number {\n    font-size: 32px;\n    margin-top: 0;\n    margin-bottom: 1.5rem;\n  }\n  \n  .step-title {\n    font-size: 15px;\n    margin-bottom: 0.75rem;\n  }\n  \n  .step-description {\n    font-size: 12px;\n    margin-bottom: 0.75rem;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
